<template>
    <div class="add-office">
        <v-dialog content-class="white" persistent v-model="progressLoad" max-width="80px">
            <v-progress-circular :size="50" indeterminate color="blue"></v-progress-circular>
        </v-dialog>
        <Header active="Offices" />
        <TopSection :heading="`${ officeId ? 'Edit' : 'Add' } Branding Group`" user="J K" :hideSearch="true" />
        <v-dialog v-model="errorDialog" persistent max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <a href="/offices" class="close-notification">
                    <v-icon class="white body-2 blue--text notification-close mr-1">close</v-icon>
                </a>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">An error has occurred.</span>
            </div>
        </v-dialog>
        <v-dialog v-model="success" persistent max-width="522px">
            <div class="notification-heading standard-height blue pr-4">
                <a href="/offices" class="close-notification">
                    <v-icon class="white body-2 blue--text notification-close mr-1">close</v-icon>
                </a>
            </div>
            <div class="notification-content white">
                <span class="primary--text font-weight-bold">Office successfully {{ officeId ? deleted ? 'deleted' : 'edited' : 'created'}}</span>
            </div>
        </v-dialog>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-container class="pt-3" grid-list-lg>
                <v-layout>
                    <v-flex xs12 md8 xl5>
                        <div class="form-section">
                            <v-layout row wrap>
                                <v-flex md12>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Branding Group name</span>
                                    </div>
                                    <v-text-field
                                        v-model="name"
                                        solo
                                        flat
                                        height="66"
                                        placeholder="Branding Group Name"
                                        v-validate="'required'"
                                        data-vv-name="name"
                                        maxlength=250
                                        :counter="250"
                                        :error-messages="errors.collect('name')"
                                        class="mb-1"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div class="form-section">
                            <v-layout row wrap>
                                <v-flex md12>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Description</span>
                                    </div>
                                    <v-textarea
                                        v-model="description"
                                        flat
                                        solo
                                        rows="9"
                                        no-resize
                                        :counter="500"
                                        maxlength=500
                                        placeholder="Descriptive test detailing who the branding group is for"
                                        class="mb-1"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div class="form-section mt-3">
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md5 class="logo-upload-flexbox">
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Logo</span>
                                    </div>
                                    <div class="white file-uploader-wrapper content-section px-4">
                                        <div :class="`file-uploader logo ${imgPreviewSrc.logo !== ''? 'uploaded' : ''}`">
                                            <input id="image-logo" ref="logo" type="file" @change="handleFileSelection($event, 'logo', 'logoFile')" 
                                            data-vv-name="logoFile" v-validate="'image'"/>
                                            <span class="subheading font-weight-bold black--text text--lighten-1">Logo</span>
                                            <div class="image-preview-wrapper">
                                                <img class="image-preview" :src="`${imgPreviewSrc.logo}`" alt="Upload preview" />
                                            </div>
                                            <v-btn fab small :class="`relative ma-0 ${imgPreviewSrc.logo == '' && 'hide'}`" @click="handleRemoveFile('logo')">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                        </div>
                                        <div :class="`file-uploader-bottom pl-4`">
                                            <span class="font-italic grey--text text--lighten-2 pl-3">{{ filename.logo }}</span>
                                            <button class="cc__box-shadow square-button upload-button" type="button" @click="uploadFile('logo')">
                                                <v-icon color="black">cloud_upload</v-icon>
                                            </button>
                                        </div>
                                    </div>
                                     <div class="v-text-field__details pl-4 ml-3">
                                        <div class="v-messages theme--light error--text">
                                            <div class="v-messages__wrapper">
                                                <div class="v-messages__message message-transition-enter-to">{{ errors.first('logoFile') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm6 md7>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Home Screen Background</span>
                                    </div>
                                    <div class="white file-uploader-wrapper content-section px-4">

                                        <div :class="`file-uploader background ${imgPreviewSrc.background !== ''? 'uploaded' : ''}`">
                                            <input id="image-background" ref="background" type="file" @change="handleFileSelection($event, 'background', 'backgroundFile')" 
                                            data-vv-name="backgroundFile" v-validate="'image'"/>
                                            <span class="subheading font-weight-bold black--text text--lighten-1">Background</span>
                                            <div class="image-preview-wrapper">
                                                <img class="image-preview" :src="`${imgPreviewSrc.background}`" alt="Upload preview" />
                                            </div>
                                            <v-btn fab small :class="`relative ma-0 ${imgPreviewSrc.background == '' && 'hide'}`" @click="handleRemoveFile('background')">
                                                <v-icon>close</v-icon>
                                            </v-btn>
                                        </div>
                                        <div :class="`file-uploader-bottom pl-4`">
                                            <span class="font-italic grey--text text--lighten-2 pl-3">{{ filename.background }}</span>
                                            <button class="cc__box-shadow square-button upload-button" type="button" @click="uploadFile('background')">
                                                <v-icon color="black">cloud_upload</v-icon>
                                            </button>
                                        </div>
                                    </div>
                                     <div class="v-text-field__details pl-4 ml-3">
                                        <div class="v-messages theme--light error--text">
                                            <div class="v-messages__wrapper">
                                                <div class="v-messages__message message-transition-enter-to">{{ errors.first('backgroundFile') }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div class="form-section mt-4 pt-2">
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md5>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Accent Colour</span>
                                    </div>
                                    <div class="white content-section py-2 pr-2 pl-4 color-selector relative">
                                        <span class="primary--text pl-3">{{ color.hex }}</span>
                                        <div @click="showColorPicker = !showColorPicker"
                                             :v-model="color"
                                             v-bind:style="{background: color.hex}"
                                             right
                                             class="color-preview"></div>
                                        <div :v-model="showColorPicker"
                                             :class="`color-range relative ${showColorPicker ? '' : 'hide'}`">
                                            <sketch-picker v-model="color"></sketch-picker>
                                        </div>
                                    </div>
                                    <v-btn :class="`full-width relative ma-0 ${showColorPicker ? '' : 'hide'}`" @click="closeColerPicker()">
                                        <span>Save colour and exit</span>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12 sm6 md7>
                                    <div class="standard-height blue py-4 px-4 cc__box-shadow relative">
                                        <span class="pl-3 white--text subheading font-weight-bold">Theme</span>
                                    </div>
                                    <v-select height="66"
                                        background-color="white"
                                        color="primary"
                                        :items="items"
                                        v-model="selectedTheme"
                                        append-icon="keyboard_arrow_down"
                                        :hide-details="true"
                                        solo></v-select>
                                </v-flex>
                            </v-layout>
                        </div>
                        <div class="form-section pt-1">
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md5>
                                    <v-btn @click="submit"
                                        block
                                        large
                                        color="grey lighten-1"
                                        class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                        <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">{{ officeId ? 'Save changes' : 'Create Branding Group'}}</span>
                                        <v-icon right class="white--text title">{{officeId ? 'save' : 'add'}}</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12 sm6 md5>
                                    <v-btn @click="$router.push(`/offices`)"
                                           block
                                           large
                                           color="grey lighten-1"
                                           class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                        <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Cancel</span>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex v-if="officeId" xs5>
                                    <v-btn @click="dialog = true"
                                           block
                                           large
                                           color="grey lighten-1"
                                           class="mt-3 pl-4 pr-3 text-icon-button ml-0">
                                        <span class="pl-3 white--text subheading text-capitalize font-weight-bold pl-3">Delete</span>
                                        <v-icon right class="white--text title">delete</v-icon>
                                    </v-btn>
                                    <v-dialog v-model="dialog" persistent max-width="520">
                                        <div class="notification-heading standard-height blue pr-4">
                                            <v-icon @click="$router.push(`/offices`)" class="white body-2 blue--text notification-close mr-1">close</v-icon>
                                        </div>
                                        <v-card class="pt-4 pb-3">
                                            <v-card-title class="justify-center subtitle primary--text font-weight-bold">
                                                <div>Do you really want to delete?</div>
                                                <div class="delete-office-warning">All users associated with this office will be moved to the default office!</div>
                                            </v-card-title>
                                            <v-card-actions>
                                                <v-btn class="white--text" color="grey lighten-1" grey @click="dialog = false">Cancel </v-btn>
                                                <v-spacer></v-spacer>
                                                <v-btn class="white--text" color="grey lighten-1" grey @click="submit('delete')">Confirm</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    let colors = {
        hex: "#194d33",
        hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
        hsv: { h: 150, s: 0.66, v: 0.3, a: 1 },
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1
    };
    let color = {
        hex: "#fff"
    };
    let showColorPicker = false;
    let imgPreviewSrc = {
        logo: "",
        background: ""
    };
    let filename = {
        logo: "",
        background: ""
    };
    let selectedTheme = "";

    import officeService from "../services/office";
    import TopSection from "../components/TopSection.vue";
    import Header from "../components/Header.vue";
    import router from "../router";
    import { Sketch } from "vue-color";
    import VueNumericInput from "vue-numeric-input";
    import VeeValidate from 'vee-validate'
    import Vue from 'vue'

    Vue.use(VeeValidate);

    export default {
        name: "App",
        components: {
            Header,
            TopSection,
            "sketch-picker": Sketch,
        },
        $_veeValidate: {
            validator: 'new'
        },
        mounted() {
            this.$validator.localize('en', this.dictionary)
        },
        data() {
            return {
                progressLoad: false,
                disableName: false,
                errorDialog: false,
                dialog: false,
                description: '',
                deleted: false,
                image: '',
                officeId: this.$route.params.id,
                companyId: sessionStorage.companyId,
                officeData: [],
                color,
                colors,
                items: [],
                showColorPicker,
                filename,
                valid: true,
                name: "",
                reader: new FileReader(),
                imgPreviewSrc,
                success: false,
                dictionary: {
                    custom: {
                        name: {
                            required: () => 'Office name is required'
                        },
                        logoFile: {
                            image: () =>'Logo must be an image'
                        },
                        backgroundFile: {
                            image: () =>'Background must be an image'
                        }
                    }
                },
                selectedTheme,
                logoFile: '',
                backgroundFile: '',
                shouldDeleteLogo: false,
                shouldDeleteDashboardBackground: false,
            };
        },
        methods: {
            closeColerPicker(){
                this.showColorPicker = false;
            },
            async getImageSaved(imageSaved, type){
                var imageData = imageSaved.split('/');
                if(imageData[imageData.length - 1] != ''){
                    this.image = await officeService.getImage(this.companyId, this.officeId, imageData[imageData.length - 1])
                    this.imagine = URL.createObjectURL(this.image.data);
                    this.imgPreviewSrc[type] = this.imagine;
                    this.filename[type] = imageData[imageData.length - 1];
                }
            },
            handleFileSelection(event, type, field) {
                this.$validator.validate(field).then(result => {
                    if(result){
                        this.filename[type] = event.target.files[0].name;
                        if(type == 'logo'){
                            this.logoFile = event.target.files[0];
                            this.shouldDeleteLogo = false;
                        }else{
                            this.backgroundFile = event.target.files[0];
                            this.shouldDeleteDashboardBackground = false;
                        }
                        let reader = new FileReader();
                        
                        reader.onload = (e) => {
                            this.imgPreviewSrc[type] = e.target.result
                        }
                        reader.readAsDataURL(event.target.files[0]);
                    }
                });
            },
            handleRemoveFile(type) {
                if (type == 'logo') {
                    this.shouldDeleteLogo = true;
                } else {
                    this.shouldDeleteDashboardBackground = true;
                }
                this.$refs[type].value = '';
                this.imgPreviewSrc[type] = '';
                this.filename[type] = null;
            },
            uploadFile(type) {
                document.getElementById('image-' + type).click();
            },
            async fetchData() {
                this.items = await officeService.getThemes();
                this.items = this.items.data;
                if (this.officeId) {
                    this.officeData = await officeService.fetchOfficeById(this.officeId);
                    this.name = this.officeData.data.name;
                    this.description = this.officeData.data.description;
                    this.color.hex = this.officeData.data.accentColor;
                    this.selectedTheme = this.officeData.data.theme;
                    this.getImageSaved(this.officeData.data.dashboardBackground, 'background');
                    this.getImageSaved(this.officeData.data.logo, 'logo');
                }
                
            },
            async submit(event) {
                this.$validator.validate('name').then(result => {
                    if(result){
                        this.progressLoad = true;
                        if (this.officeId) {
                            if (event == "delete") {
                                this.dialog = false;
                                officeService.delete(this.officeId)
                                .then(res => {
                                    this.progressLoad = false;
                                    if (res.data.status == 1) {
                                        this.success = true;
                                        this.deleted = true;
                                    }
                                })
                                .catch(err => {
                                    this.progressLoad = false;
                                    this.errorDialog = true;
                                });
                            } else {
                                // UPDATE action
                                var dataUpdate = new FormData();
                                dataUpdate.append('companyId', this.companyId);
                                dataUpdate.append('name', this.name);
                                dataUpdate.append('logo', this.logoFile);
                                dataUpdate.append('ShouldDeleteLogo', this.shouldDeleteLogo);
                                dataUpdate.append('dashboardBackground', this.backgroundFile);
                                dataUpdate.append('ShouldDeleteDashboardBackground', this.shouldDeleteDashboardBackground);
                                dataUpdate.append('accentColor', this.color.hex);
                                dataUpdate.append('theme', this.selectedTheme);
                                dataUpdate.append('description', this.description);
                                officeService.update(this.officeId, dataUpdate)
                                    .then(res => {
                                        this.progressLoad = false;
                                        if (res.data.status == 1) {
                                            this.success = true;
                                        }
                                    })
                                    .catch(err => {
                                        this.progressLoad = false;
                                        this.errorDialog = true;
                                    });
                            }
                        } else {
                            // CREATE NEW OFFICE
                            var dataCreate = new FormData();
                            dataCreate.append('name', this.name);
                            dataCreate.append('companyId', this.companyId);
                            dataCreate.append('logo', this.logoFile);
                            dataCreate.append('dashboardBackground', this.backgroundFile);
                            dataCreate.append('accentColor', this.color.hex);
                            dataCreate.append('theme', this.selectedTheme);
                            dataCreate.append('description', this.description);
                            officeService.create(dataCreate)
                                .then(res => {
                                    this.progressLoad = false;
                                    if (res.data.status == 1) {
                                        this.success = true;
                                    }
                                })
                                .catch(err => {
                                    this.progressLoad = false;
                                    this.errorDialog = true;
                                });
                        }
                    }
                });
            }
        },
        created() {
            this.fetchData();
        }
    };
</script>

<style lang="scss">
    .delete-office-warning {
        text-align: center;
    }
</style>



